export type { DirectLink } from '@src/core/buyerApiClient';

// The generated client types `DirectLink.type` as a bare string; these are the values it carries.
export const DirectLinkType = {
  Cart: 'cart',
  Sale: 'sale',
  Payment: 'payment',
  Order: 'order',
} as const;

export type DirectLinkType = (typeof DirectLinkType)[keyof typeof DirectLinkType];

// Same story with `DirectLink.status`: core has a DirectLinkStatusEnum, and the buyer gateway casts
// it to a bare string when it serialises the link, so the client never sees it. These are the values
// it carries — replace this the day the API returns the enum.
export const DirectLinkStatus = {
  Created: 'created',
  PaymentComplete: 'payment_complete',
  PaymentVoided: 'payment_voided',
  PaymentChargeback: 'payment_chargeback',
  Expired: 'expired',
  Canceled: 'canceled',
} as const;

export type DirectLinkStatus = (typeof DirectLinkStatus)[keyof typeof DirectLinkStatus];
